import React from 'react';
import { Box, SkeletonLoader } from '@saviynt/design-system';

import './Shared.css';

interface ListSkeletonProps {
  count: number;
}

/**
 * ListSkeleton
 */
function ListSkeleton({ count }: ListSkeletonProps) {
  const fillerArray = Array(count)
    .fill(0)
    .map((_, index) => index);

  return (
    <Box tag='div' className='ListSkeleton-wrapper'>
      {fillerArray.map((item) => (
        <Box key={item} className='ListSkeleton'>
          <SkeletonLoader
            shape='circle'
            animationStyle='wave'
            height='3rem'
            width='3.25rem'
          />
          <SkeletonLoader
            shape='square'
            animationStyle='wave'
            height='3.5rem'
            width='100%'
          />
        </Box>
      ))}
    </Box>
  );
}

export default ListSkeleton;
